<div class="container" id="JobCardPrint" style="height: 100%; overflow: hidden; margin: 0px; padding: 0px; width: 100%;">
    <div style="width: 100%; font-family: Calibri;">
        <span *ngIf="jobTypeID == 1"><h2 class="headerLblcontent">Job Card</h2></span>
        <span *ngIf="jobTypeID == 2">
            <h2 class="headerLblcontent">
                <span class="fntheaderSml">Project Summary</span> <br>
                {{jobDetails.JobNo}}
            </h2>
        </span>
        <!--Header-->
        <div class="row" style="margin: 3px; display: flex; align-items: flex-end;">
            <div style="width: 50%; text-align: left; padding: 0px 15px;">
                <div *ngIf="jobDetails.CstrRelName != ''">
                    <span class="fontstyle">Customer : </span><span class="lableCls">{{jobDetails.CstrRelName}}</span><br>
                </div>
                <div *ngIf="jobTypeID == 2 && productItems.length > 0">
                    <span class="fontstyle">Project Type : </span><span class="lableCls">{{productItems[0]?.ItemName}}</span><br>
                    <span class="fontstyle">Project Type code : </span><span class="lableCls">{{productItems[0]?.ItemCode}}</span><br>
                </div>
            </div>
            <div style="width: 50%; text-align: right; padding: 0px 15px;">
                <div *ngIf="jobTypeID == 1">
                    <span class="fontstyle">WIP No. : </span><span class="lableCls">{{jobDetails.JobNo}}</span><br>
                </div>
                <span class="fontstyle">Launched on : </span><span class="lableCls">{{jobDetails.LaunchDT | date: 'dd-MMM-yy'}}</span><br>  
                <div *ngIf="jobTypeID == 2">
                    <span class="fontstyle">Due on : </span><span class="lableCls">{{jobDetails.TargetDT | date: 'dd-MMM-yy'}}</span><br>  
                </div>
            </div>
        </div>
            <!-- product details -->
            <div class="col-md-12 col-sm-12 col-xs-12 pad0 webView" style="margin-top: 25px;">
                <table *ngIf="jobTypeID == 1" class="table table-bordered">
                    <thead>
                        <tr style="text-align: left;">
                            <th  style="width:25%; padding: 10px !important; line-height: 17px;">Product</th>
                            <th style="width: 15%; padding: 10px !important; line-height: 17px;">Code</th>
                            <th *ngIf="jobTypeID == 1" style="width: 10%;text-align: right; padding: 10px !important; line-height: 17px;">Launch Qty</th>
                            <th *ngIf="jobTypeID == 1" style="width: 6%; padding: 10px !important; line-height: 17px;">Unit</th>
                            <th style="width: 8%; padding: 10px !important; line-height: 17px;">Launched on</th>
                            <th style="width: 8%; padding: 10px !important; line-height: 17px;">Due by</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let p of productItems;">
                            <td style="padding: 10px !important;">
                                <div style="display: flex; flex-direction: column; gap: 0px;">
                                <span style="font-size: 16px; {{prtCfg.itemDesc && p.Details != '' ? 'font-weight: bold; line-height: 27px;' : ''}}">{{p.ItemName}}</span>  
                                <span *ngIf="prtCfg.itemDesc && p.Details != ''" style="font-size: 14px; white-space: pre-wrap;">{{p.Details}}</span>
                                </div>
                            </td>
                            <td style="padding: 10px !important;">
                                <span style="font-size: 16px;">{{p.ItemCode}}</span>
                            </td>
                            <td *ngIf="jobTypeID == 1" style="text-align: right; padding: 10px !important;">
                                <span style="font-size: 16px;">{{p.PlanQty}}</span>
                            </td>
                            <td *ngIf="jobTypeID == 1" style="padding: 10px !important;">
                                <span style="font-size: 16px;">{{p.SKU}}</span>
                            </td>
                            <td style="padding: 10px !important;">
                                <span style="font-size: 16px;">{{jobDetails.LaunchDT | date: 'dd-MMM-yy'}}</span>
                            </td>
                            <td style="padding: 10px !important;">
                                <span style="font-size: 16px;">{{jobDetails.TargetDT | date: 'dd-MMM-yy'}}</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <!-- Production Stage -->
            <div *ngIf="jobTypeID == 1 && moveStages.length > 0" class="col-md-12" style="text-align: left; margin-top: 20px;">
                <span class="lableMainHeading" style="font-size:19px;"> Stages </span>
            </div>
            <div *ngIf="jobTypeID == 1 && moveStages.length > 0" class="col-md-12 col-sm-12 col-xs-12 pad0 webView" style="margin-top: 10px;">
                <table class="table table-bordered">
                    <thead class="tableheader">
                        <tr style="text-align: left;">
                            <th style="width: 25%; padding: 10px !important;">Stage</th>
                            <th *ngIf="jobTypeID == 1" style="width: 5%; padding: 10px !important;">Opng.</th>
                            <th *ngIf="jobTypeID == 1" style="width: 5%; padding: 10px !important;">Done</th>
                            <th *ngIf="jobTypeID == 1" style="width: 5%; padding: 10px !important;">Rej.</th>
                            <th *ngIf="jobTypeID == 1"style="width: 8%; padding: 10px !important;">Unit</th>
                            <th style="width: 12%; padding: 10px !important;">Done on</th>
                            <th style="width: 15%; padding: 10px !important;">Done by</th>
                            <th style="width: 27%; padding: 10px !important;">Notes</th>
                        </tr>
                    </thead>
                    <tbody >
                        <tr *ngFor="let s of moveStages;">
                            <td style="padding: 10px !important; font-size: 16px !important;">
                                <span>{{s.stageName}}</span>
                            </td>
                            <td *ngIf="jobTypeID == 1"style="text-align: right; padding: 10px !important; font-size: 16px !important;">
                                <span>{{s.opngQty}}</span>
                            </td>
                            <td *ngIf="jobTypeID == 1" style="text-align: right; padding: 10px !important; font-size: 16px !important;">
                                <span>{{s.doneQty}}</span>
                            </td>
                            <td *ngIf="jobTypeID == 1" style="text-align: right; padding: 10px !important; font-size: 16px !important;">
                                <span>{{s.rejQty}}</span>
                            </td>
                            <td *ngIf="jobTypeID == 1"style="text-align: left; padding: 10px !important; font-size: 16px !important;">
                                <span>{{s.unit}}</span>
                            </td>
                            <td style="padding: 10px !important; font-size: 16px !important;">
                                <span>{{s.doneOn | date: 'dd-MMM-yy' }}</span>
                            </td>
                            <td style="padding: 10px !important; font-size: 16px !important;">
                                <span>{{s.doneBy}}</span>
                            </td>
                            <td style="padding: 10px !important; font-size: 16px !important;">
                                <span style="white-space: pre-wrap;">{{s.note ? s.note : '-'}}</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <!-- Project Stage -->
            <div *ngIf="jobTypeID == 2 && prjStages.length > 0" class="col-md-12" style="text-align: left; margin-top: 10px;">
                <span class="lableMainHeading"> Progress Tracker </span>
            </div>
            <div *ngIf="jobTypeID == 2 && prjStages.length > 0" class="col-md-12 col-sm-12 col-xs-12 pad0 webView" style="margin-top: 10px;">
                <table class="table table-bordered">
                    <thead>
                        <tr>
                            <th style="max-width: 30%;">Stage</th>
                            <th>Started on</th>
                            <th>Started by</th>
                            <th>Due on</th>
                            <th>Done on</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let s of prjStages" (click)="openTaskListModal(s)" style="cursor: pointer;">
                            <td style="text-align: left; vertical-align: inherit;">{{s.SNm}}</td>
                            <td style="text-align: left; vertical-align: inherit;">{{s.startDT}}</td>
                            <td style="text-align: left; vertical-align: inherit;">{{s.by ? s.by : '-'}}</td>
                            <td style="text-align: left; vertical-align: inherit;">{{s.targetDT}}</td>
                            <td style="text-align: left; vertical-align: inherit;">{{s.endDT}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div *ngIf="jobCardDetails.length > 0" class="col-md-12" style="text-align: left; margin-top: 20px;">
                <span class="lableMainHeading" style="font-size:19px;"> Material Consumption </span>
            </div>
             <!--ProductItem Job Card -->
             <div *ngIf="jobCardDetails.length > 0" class="col-md-12 col-sm-12 col-xs-12 pad0 webView" style="margin-top: 10px;">
                <table class="table table-bordered">
                    <thead class="tableheader">
                        <tr style="text-align: left;">
                            <th style="width: 15%; padding: 10px !important;">Item</th>
                            <th style="width: 15%; padding: 10px !important;">Code</th>
                            <th style="width: 4%;text-align: right; padding: 10px !important;">Plan Qty</th>
                            <th style="width: 4%;text-align: right; padding: 10px !important;">Used Qty</th>
                            <th style="width: 5%; padding: 10px !important;">Unit</th>
                        </tr>
                    </thead>
                    <tbody >
                        <tr *ngFor="let j of jobCardDetails;">
                            <td style="padding: 10px !important;">
                                <div style="display: flex; flex-direction: column; gap: 0px;">
                                	<span style="font-size: 16px; {{prtCfg.itemDesc && j.Details != '' ? 'font-weight: bold; line-height: 27px;' : ''}}" >{{j.ItemName}}</span>  
                                	<span *ngIf="prtCfg.itemDesc && j.Details != ''" style="font-size: 14px; white-space: pre-wrap;">{{j.Details}}</span>
                                </div>
                            </td>
                            <td style="padding: 10px !important;">
                                <span style="font-size: 16px;">{{j.ItemCode}}</span>
                            </td>
                            <td style="text-align: right; padding: 10px !important;">
                                <span style="font-size: 16px;">{{j.PlanQty}}</span>
                            </td>
                            <td style="text-align: right; padding: 10px !important;">
                                <span style="font-size: 16px;">{{j.UsedQty}}</span>
                            </td>
                            <td style="padding: 10px !important;">
                                <span style="font-size: 16px;">{{j.SKU}}</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="col-md-12 col-sm-12 col-xs-12 pad0" *ngIf="prtCfg.jobInst && jobDetails.Instructions != '' && jobTypeID == 1">
                <span class="lableMainHeading" style="font-size:19px; text-align: left;margin-left: 3px;">Instruction</span>
                <table class="table table-bordered no-horizontal-lines" style="border-right-width: 1px !important;margin-top: 4px;">
                    <thead>
                        <tr>
                            <th style="border-top: none !important; padding: 10px !important;font-weight: normal; padding-top: 5px !important; line-height: 19px;">
                                <span [ngStyle]="{'font-size': '16px', 'white-space': 'pre-wrap'}" >
                                    {{ jobDetails.Instructions }}
                                </span>
                            </th>
                        </tr>
                    </thead>
                    <tbody></tbody>
                </table>
            </div>
      </div>
  </div>
